/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'document': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M10.5 7h-7c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h7c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5zm-3-3h-4c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h4c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5zm3 6h-7c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h7c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5zM2 14V2h7v2.5c0 .28.22.5.5.5H12v9H2zm8.5-14H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V3.5c0-.28-.16-.66-.35-.85l-2.3-2.3A1.38 1.38 0 0010.5 0z" _fill="currentColor"/>'
  }
})
